import React, { useLayoutEffect, useRef } from "react";
import "./Lessons.css"; 
import { gsap } from "gsap"; 

// --- MANUAL LESSON LIST ---
// Paste your Google Drive links here!
const lessonsList = [
  { 
    id: 1, 
    title: "Lesson 1", 
    link: "https://drive.google.com/file/d/1HmFGNQEM2S_J2AQ31U4XxS-7uzefBI-j/view?usp=sharing" 
  },
  { 
    id: 2, 
    title: "Lesson 2", 
    link: "https://drive.google.com/file/d/1pfTN83v598XvXaQdBxbZax_wqxVr-HX3/view?usp=sharing" 
  },
  { 
    id: 3, 
    title: "Lesson 3", 
    link: "https://drive.google.com/file/d/1pIhUWHEhG7kVM6EkqwHY78FWSqG5zk21/view?usp=sharing" 
  },
  { 
    id: 4, 
    title: "Lesson 4", 
    link: "https://drive.google.com/file/d/1fKFSi-0C-5aCko9pwRsP7q4WZpAKXWiY/view?usp=sharing" 
  },
  { 
    id: 5, 
    title: "Lesson 5", 
    link: "https://drive.google.com/file/d/12sMmMNIVmlF3TXI295YS_743pna2LNIs/view?usp=sharing" 
  },
  { 
    id: 6, 
    title: "Lesson 6", 
    link: "https://drive.google.com/file/d/1HzWBBP3LNdeZdYCjOTIAo8PPVXEI63Na/view?usp=sharing" 
  },
  { 
    id: 7, 
    title: "Lesson 7", 
    link: "https://drive.google.com/file/d/1YwAPNhOGxcqOIpkZOavOXukND67qm0HA/view?usp=sharing" 
  },
  { 
    id: 8, 
    title: "Lesson 8", 
    link: "https://drive.google.com/file/d/1ZNi_oPBw0y6N_reOjlg1XEZTZI-gu7yT/view?usp=sharing" 
  },
  { 
    id: 9, 
    title: "Lesson 9", 
    link: "https://drive.google.com/file/d/19BfUTRtr_m3IjXD5PDwEchwTIJlY3N3q/view?usp=sharing" 
  },
  { 
    id: 10, 
    title: "Lesson 10", 
    link: "https://drive.google.com/file/d/1YvrqFEL8nTAE-_3rnUrnAB2tQFngTqJ3/view?usp=sharing" 
  },
  { 
    id: 11, 
    title: "Lesson 11", 
    link: "https://drive.google.com/file/d/1oJ-IPY1N83mA6HYRscRzKPwYFEIxi7lH/view?usp=sharing" 
  },
  { 
    id: 12, 
    title: "Lesson 12", 
    link: "https://drive.google.com/file/d/1ykvuuU8R69X-rgZyKHSTTCu-sbBF9cuT/view?usp=sharing" 
  },
  { 
    id: 13, 
    title: "Lesson 13", 
    link: "https://drive.google.com/file/d/1sBy6if0q1D_Cbc30ON2yNcIBpTPHRA8E/view?usp=sharing" 
  },
  { 
    id: 14, 
    title: "Lesson 14", 
    link: "https://drive.google.com/file/d/1Joyd6ljqfwUdKeFj7OcUOevbzn0SQgNZ/view?usp=sharing" 
  },
  { 
    id: 15, 
    title: "Lesson 15", 
    link: "https://drive.google.com/file/d/1T21v2XrU-dLwjrpZaI_EWrxgZBeWVrTi/view?usp=sharing" 
  },
];

function Lessons() {
  const containerRef = useRef(null);
  const listRef = useRef(null);

  useLayoutEffect(() => {
    document.title = "Lessons | Dandelion Run Community";
    const ctx = gsap.context(() => {
      // Fade in the container
      gsap.fromTo(
        containerRef.current,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" }
      );

      // Stagger in the list items
      gsap.fromTo(
        ".lesson-item",
        { opacity: 0, x: -20 },
        {
          opacity: 1,
          x: 0,
          duration: 0.5,
          stagger: 0.1, // Waterfall effect for the list
          ease: "power2.out",
          delay: 0.3
        }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="lessons-page-section">
      
      {/* Reuse the Glass Container Style */}
      <div className="glass-content-container" ref={containerRef}>
        <h2 className="lessons-title">Member Lessons</h2>
        <p className="lessons-subtitle">
          Click a lesson below to download the PDF guide.
        </p>

        <div className="lessons-list" ref={listRef}>
          {lessonsList.map((lesson) => (
            <a 
              key={lesson.id} 
              href={lesson.link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="lesson-item"
            >
              <span className="lesson-number">{lesson.id}</span>
              <span className="lesson-name">{lesson.title}</span>
              <span className="lesson-arrow">→</span>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Lessons;